import { api } from '@/scripts/api';

export const PaymentMethodsService = {
    /**
     * @param accountTypeId {number}
     * @param accountType {'client' | 'agency'}
     */
    async getAll(accountTypeId, accountType) {
        return new Promise((resolve, reject) => {
            const service = `/ms/billing/v1/payment-methods/${accountType}/${accountTypeId}/configuration`;
            api
                .get(service)
                .then(resolve)
                .catch(reject);
        });
    },

    /**
     * @param accountTypeId {number}
     * @param accountType {'client' | 'agency'}
     */
    getAllVerified(accountTypeId, accountType) {
        return new Promise((resolve, reject) => {
            const service = `/ms/billing/v1/payment-methods/${accountType}/${accountTypeId}`;
            api
                .get(service)
                .then(resolve)
                .catch(reject);
        });
    },

    delete(paymentMethodId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/billing/v1/payment-methods/${paymentMethodId}`;
            api
                .delete(service)
                .then(resolve)
                .catch(reject);
        });
    },

    changeDefault(paymentMethodId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/billing/v1/payment-methods/set-default/${paymentMethodId}`;
            api
                .put(service)
                .then(resolve)
                .catch(reject);
        })
    },

    create(body, userId, userType) {
        return new Promise((resolve, reject) => {
            const service = `/ms/billing/v1/payment-methods/${userType}/${userId}`;
            api
                .post(service, body)
                .then(resolve)
                .catch(reject);
        })
    },

    verify(body, userId, userType) {
        return new Promise((resolve, reject) => {
            const service = `/ms/billing/v1/payment-methods/${userType}/${userId}/verify`;
            api
                .post(service, body)
                .then(resolve)
                .catch(reject);
        })
    },

    loginCreate(body, userType){
        return new Promise((resolve, reject) => {
            const service = `/ms/billing/v1/payment-gateway/${userType}/payment`;
            api
                .post(service, body)
                .then(resolve)
                .catch(reject);
        })
    },

    getConnectedAccount(userId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/billing/v1/connected-account/${userId}`;
            api
                .get(service)
                .then(resolve)
                .catch(reject);
        })
    },

    getConnectedAccountOnboardingUrl(userId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/billing/v1/connected-account/${userId}/onboardingurl`;
            api
                .get(service)
                .then(resolve)
                .catch(reject);
        })
    },

    createConnectedAccount(body, userId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/billing/v1/connected-account/${userId}`;
            api
                .post(service, body)
                .then(resolve)
                .catch(reject);
        })
    },

    updateConnectedAccount(body, accountId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/billing/v1/connected-account/${accountId}`;
            api
                .msPatch(service, body)
                .then(resolve)
                .catch(reject);
        })
    },
}